import { render } from "./profile-blocks.vue?vue&type=template&id=62dadbec&scoped=true"
import script from "./profile-blocks.vue?vue&type=script&lang=js"
export * from "./profile-blocks.vue?vue&type=script&lang=js"

import "./profile-blocks.vue?vue&type=style&index=0&id=62dadbec&scoped=true&lang=css"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62dadbec"]])

export default __exports__